import {useLocation} from 'react-router-dom';

export function useURLQueryParams(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}
